<template>
  <div class="container">
    <!-- 顶部导航栏 -->
    <div class="header">
      <h1 class="title">开通会员，提升招聘效率</h1>
    </div>

    <!-- 用户信息卡片 -->
    <div class="user-card">
      <div class="avatar-box">
        <img :src="userInfo.avatarUrl" alt="Avatar" class="avatar" />
      </div>
      <div class="user-info">
        <div class="phone">{{ userInfo.phone }}</div>
        <div class="status">
          {{
            userInfo.isVip == true
              ? userInfo.startTime + "-" + userInfo.endTime
              : "未开通会员，开通会员享权益"
          }}
        </div>
      </div>
    </div>

    <!-- 价格选择卡片 -->
    <div class="price-card">
      <!-- 月卡 -->
      <div
        :class="['price-item', active == 0 ? 'active' : '']"
        @click="Select(0)"
      >
        <div class="tag" v-if="info.firstPurchaseMonthCard == true">
          {{ info.monthCardDesc }}
        </div>
        <div class="price-main">
          <span class="num">{{ info.monthCardPrice || 129 }}</span>
          <span class="unit">元</span>
        </div>
        <div class="desc">月卡/30天</div>
      </div>

      <!-- 年卡 -->
      <div
        :class="['price-item', active == 1 ? 'active' : '']"
        @click="Select(1)"
      >
        <div class="tag" v-if="info.firstPurchaseYearCard == true">
          {{ info.yearCardDesc }}
        </div>
        <div class="price-main">
          <span class="num">{{ info.yearCardPrice || 1298 }}</span>
          <span class="unit">元</span>
        </div>
        <div class="desc">年卡/365天</div>
      </div>
    </div>

    <!-- 权益介绍 -->
    <div class="benefits-section"></div>

    <!-- 购买须知 -->
    <div class="notice-section">
      <div class="section-header">会员购买须知</div>
      <div class="icon"></div>
      <div class="notice-content">
        <p v-for="(item, index) in notices" :key="index">
          <span class="dot">{{ index + 1 }}.</span>{{ item }}
        </p>
        <div class="agreement">
          *完成购买即表示您已同意并接受
          <a href="https://down.baoanlailou.com/file/vip.html" class="link"
            >《咖德会员协议》</a
          >的全部条款。
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="boxBottom">
      <div class="bottomBox">
        <div class="footer-bar" @click="pay()">
          <div class="price-info">
            <span
              class="discount"
              v-if="
                info.monthCardOriginalPrice - info.monthCardPrice > 0 ||
                  info.yearCardOriginalPrice - info.yearCardPrice > 0
              "
              >已优惠{{
                active === 0
                  ? info.monthCardOriginalPrice - info.monthCardPrice
                  : info.yearCardOriginalPrice - info.yearCardPrice
              }}元</span
            >
            <div class="price-group">
              <span class="current-price"
                >{{
                  active === 0
                    ? info.monthCardPrice || 129
                    : info.yearCardPrice || 1298
                }}元/{{ active === 0 ? 30 : 365 }}天</span
              >
              <span
                class="origin-price"
                v-if="
                  info.monthCardOriginalPrice - info.monthCardPrice > 0 ||
                    info.yearCardOriginalPrice - info.yearCardPrice > 0
                "
                >{{
                  active === 0
                    ? info.monthCardOriginalPrice
                    : info.yearCardOriginalPrice
                }}元</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MembershipPage",
  data() {
    return {
      active: 0,
      notices: [
        "生效规则:会员购买后即刻生效，立即解锁全部对应权益。",
        "权益差异:不同会员等级包含的权益有所区别，请在购买前仔细阅读页面展示的权益详情。",
        "岗位有效期:您发布的招聘岗位信息将会与会员身份同步到期，为避免岗位无法查看，建议您在会员到期前及时续费，以延长岗位有效时间。",
        "退款规则:本产品为数字化服务，一经购买，不支持退款。",
        "客服支持:如有任何疑问或需要帮助，请联系在线客服。"
      ],
      info: {},
      userInfo: {}
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // this.getInfo();
  },
  methods: {
    Select(index) {
      this.active = index;
    },
    getInfo() {
      this.$axios
        .post(`/mapi/api/custom/pay/query-member-price`)
        .then(({ data }) => {
          this.info = data;
        });
    },
    pay() {
      this.$axios
        .post(`/mapi/api/custom/pay/purchase-member`, param)
        .then(({ data }) => {
          this.$router.push("/buySuccess");
        });
    }
  }
};
</script>

<style scoped>
/* 全局重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background-color: #f5f5f5;
}

.container {
  max-width: 414px; /* 模拟手机宽度 */
  margin: 0 auto;
  background-color: #f5f5f5;
  height: 100vh;
  padding-bottom: 50px; /* 为底部按钮留出空间 */
  box-sizing: border-box;
  overflow: scroll;
}

/* 头部样式 */
.header {
  background-image: url("/static/buyTop.png");
  background-size: cover;
  color: white;
  padding: 40px 20px 80px;
  text-align: center;
  position: relative;
}

.back-btn {
  position: absolute;
  left: 20px;
  top: 40px;
  font-size: 24px;
  cursor: pointer;
}

.title {
  font-size: 18px;
  font-weight: normal;
}

/* 用户卡片 */
.user-card {
  margin: -60px 12px 15px;
  background-image: url("/static/buyBg.png");
  background-size: cover;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 2;
}

.avatar-box {
  margin-right: 15px;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.6);
}

.user-info .phone {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.user-info .status {
  font-size: 12px;
  color: #666;
}

/* 价格卡片 */
.price-card {
  margin: 0 12px 15px;
  /* background: white; */
  border-radius: 12px;
  /* padding: 20px; */
  display: flex;
  justify-content: space-between;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03); */
}

.price-item {
  flex: 1;
  text-align: center;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 15px 10px;
  margin: 0 10px;
  position: relative;
  background-color: #fff;
  overflow: hidden;
}

/* 选中状态样式 */
.price-item.active {
  border-color: #f9dca5 !important;
  background: #fffdf5 !important;
  color: #fe671d !important;
}

.tag {
  position: absolute;
  top: 0;
  right: 0;
  color: white;
  font-size: 10px;
  width: 96px;
  height: 19px;
  line-height: 19px;
  background: #fe671d;
  border-radius: 0px 0px 0px 8px;
}

.price-main {
  margin-top: 10px;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.num {
  font-size: 28px;
  font-weight: bold;
  font-family: "DIN Alternate", sans-serif;
}

.unit {
  font-size: 12px;
  margin-left: 2px;
}

.desc {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

/* 通用区域样式 */
.benefits-section {
  height: 267px;
  margin: 0 12px 15px;
  background-image: url("/static/buyInfo.png");
  background-size: cover;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}
.notice-section {
  margin: 0 12px 50px;
  background: #fff;
  background-size: cover;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.section-header {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  padding-left: 10px;
}
.icon {
  width: 89px;
  height: 5px;
  background: linear-gradient(90deg, #ffffff 0%, #fec702 100%);
  border-radius: 3px;
  margin-top: -20px;
  margin-left: 15px;
  margin-bottom: 10px;
}

/* 权益列表 */
.benefits-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.benefit-item {
  width: 48%;
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
  color: #666;
}

.icon {
  margin-right: 5px;
}

/* 须知列表 */
.notice-content p {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
  text-align: justify;
}

.dot {
  display: inline-block;
  width: 14px;
  height: 14px;
  /* background-color: #f5f5f5; */
  color: #999;
  /* border-radius: 50%; */
  text-align: center;
  line-height: 14px;
  font-size: 10px;
}

.agreement {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

.link {
  color: #5b7ad6;
  text-decoration: none;
}
.boxBottom {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.bottomBox {
  background: #f5f5f5;
  max-width: 414px;
  margin: 0 auto;
  padding: 20px 12px;
  box-sizing: border-box;
}
/* 底部栏 */
.footer-bar {
  width: 100%;
  height: 50px;
  background-image: url("/static/buyBtn.png");
  background-size: 100% 100%;
  padding-left: 23px;
  box-sizing: border-box;
  z-index: 10;
}

.price-info {
  display: flex;
  flex-direction: column;
  position: relative;
}

.discount {
  font-size: 12px;
  color: white;
  background-color: #ff4d4f;
  padding: 2px 6px;
  border-radius: 4px;
  width: fit-content;
  position: absolute;
  top: -12px;
}

.price-group {
  display: flex;
  align-items: baseline;
  position: absolute;
  top: 10px;
}

.current-price {
  color: #fbead9;
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
}

.origin-price {
  color: #b5a79a;
  font-size: 12px;
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/view/buy/buy.vue